export const forgotPassword = {
    title: 'Forgot password',
    content: 'Please enter your registered email',
    button: 'Submit',
    titleSwal: 'The reset password link has been sent',
    contentSwal: 'Please check your email and the reset password link',
};
